/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/* eslint-disable
    jsx-a11y/iframe-has-title
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import $ from 'jquery';
import React from 'react';

import {assertAndContinue} from 'Asserts';
import BenchlingConfig from 'BenchlingConfig';
import {EXTERNAL_FILE_TYPE} from 'constants/PreviewTypeConstants';
import SignedExtFileURLProxy from 'external-files/SignedExtFileURLProxy';
import MolstarViewer, {MOLSTAR_PREVIEW_TYPE_TO_FORMAT} from 'molbio/molstar/ViewerWrapper';
import getTestProps from 'test/lib/cypress/getTestProps';
import {Optional} from 'util/Types';

import CSVFilePreview from './CSVFilePreview';

const GOOGLE_DOCS_VIEWER_URL = 'https://docs.google.com/viewer';
const MICROSOFT_OFFICE_ONLINE_URL = 'https://view.officeapps.live.com/op/embed.aspx';

function makeIFrameURL(url: any, params: any): string {
  return `${url}?${$.param(params)}`;
}

export interface ExternalFilePreviewProps {
  previewType?: EXTERNAL_FILE_TYPE;
  url: string;
  externalFileId: string;
  owningEntityApiId: string;
  useFullHeight?: boolean;
}

class ExternalFilePreview extends React.Component<ExternalFilePreviewProps> {
  render(): JSX.Element {
    return (
      <div
        className={
          this.props.useFullHeight
            ? 'externalFilePreview-full-height externalFilePreview'
            : 'externalFilePreview'
        }
        {...getTestProps({component: 'ExternalFilePreview', element: 'root'})}
      >
        <SignedExtFileURLProxy
          url={this.props.url}
          externalFileId={this.props.externalFileId}
          owningEntityApiId={this.props.owningEntityApiId}
          renderWithSignedURL={this.renderWithSignedURL}
          // Microsoft Office Online can't directly load S3's pre-signed URL as they are too long (BNCH-11147)
          useRedirectURL={this.props.previewType === EXTERNAL_FILE_TYPE.MICROSOFT_OFFICE_ONLINE}
        />
      </div>
    );
  }

  renderNoPreview = (): JSX.Element => (
    <>
      <p className="faded text-center u-spacing-top">No preview is available for this file type.</p>
      {BenchlingConfig.PRIVATE_DEPLOY &&
      !BenchlingConfig.ELN_ENABLE_EXTERNAL_GOOGLE_VIEWER &&
      !BenchlingConfig.ELN_ENABLE_EXTERNAL_MSFT_VIEWER ? (
        // Ideally we could be smart and only show this message when the file is an Office file,
        // but that's a bit tricky because we currently do file type detection on the backend
        <p className="faded text-center u-spacing-top">
          If this file is of a supported type, Benchling may be able to show a preview using an external
          application like Google Docs or Microsoft Office. However, this sort of preview is currently
          disabled. If you think this is a mistake, please contact your administrator.
        </p>
      ) : null}
    </>
  );

  renderWithSignedURL = (signedURL: Optional<string>): JSX.Element => {
    if (signedURL === undefined) {
      return <p className="u-spacing-top faded text-center">Loading...</p>;
    }
    // eslint-disable-next-line benchlint/no-eqeqeq-null
    if (signedURL === null) {
      return <p className="u-spacing-top faded text-center">Error loading file</p>;
    }
    switch (this.props.previewType) {
      case EXTERNAL_FILE_TYPE.IMAGE:
        return (
          <div className="external-file-preview-image-wrapper">
            <div className="external-file-preview-image" style={{backgroundImage: `url('${signedURL}')`}} />
          </div>
        );
      case EXTERNAL_FILE_TYPE.CSV:
        return <CSVFilePreview url={signedURL} />;
      case EXTERNAL_FILE_TYPE.PDF:
        return <iframe src={signedURL} />;
      case EXTERNAL_FILE_TYPE.VIDEO:
        return (
          // eslint-disable-next-line jsx-a11y/media-has-caption
          <video
            src={signedURL}
            controls={true}
            style={{width: '100%', maxHeight: '400px'}}
            preload="metadata"
          >
            Your browser does not support the video tag.
          </video>
        );
      case EXTERNAL_FILE_TYPE.GOOGLE_DOCS_VIEWER:
        if (
          !assertAndContinue(
            BenchlingConfig.ELN_ENABLE_EXTERNAL_GOOGLE_VIEWER,
            'Blocked app from using Google Docs Viewer without ELN_ENABLE_EXTERNAL_GOOGLE_VIEWER'
          )
        ) {
          return this.renderNoPreview();
        }
        return <iframe src={makeIFrameURL(GOOGLE_DOCS_VIEWER_URL, {embedded: 'true', url: signedURL})} />;
      case EXTERNAL_FILE_TYPE.MICROSOFT_OFFICE_ONLINE:
        if (
          !assertAndContinue(
            BenchlingConfig.ELN_ENABLE_EXTERNAL_MSFT_VIEWER,
            'Blocked app from using Office Online Viewer without ELN_ENABLE_EXTERNAL_MSFT_VIEWER'
          )
        ) {
          return this.renderNoPreview();
        }
        return <iframe src={makeIFrameURL(MICROSOFT_OFFICE_ONLINE_URL, {src: signedURL})} />;
      case EXTERNAL_FILE_TYPE.MOLSTAR_PDB_VIEWER:
      case EXTERNAL_FILE_TYPE.MOLSTAR_PDBQT_VIEWER:
      case EXTERNAL_FILE_TYPE.MOLSTAR_MMCIF_VIEWER:
        return (
          <MolstarViewer
            url={signedURL}
            format={MOLSTAR_PREVIEW_TYPE_TO_FORMAT[this.props.previewType]}
            className="external-file-preview-image-wrapper"
          />
        );
      default:
        return this.renderNoPreview();
    }
  };
}

export default ExternalFilePreview;
